const GoogleMapsApiKey = 'AIzaSyCbUJvH7kralTBxkG8K35ubLjBkwkr7y5Q'

export default GoogleMapsApiKey
